// @mui material components
import Card from "@mui/material/Card";

// Material Kit 2 React components
import MKBox from "components/MKBox";
import SEO from "components/SEO";

// SEO structured data
import { buildBreadcrumbSchema } from "config/structuredData";

// Material Kit 2 React examples
import DefaultNavbar from "examples/Navbars/DefaultNavbar";
import DefaultFooter from "examples/Footers/DefaultFooter";

// Car Rentals page sections
import Fleet from "pages/CarRentals/sections/Fleet";
import LargerGroupNote from "pages/CarRentals/sections/LargerGroupNote";
import HowItWorks from "pages/CarRentals/sections/HowItWorks";
import VanGallery from "pages/CarRentals/sections/VanGallery";
import Terms from "pages/CarRentals/sections/Terms";
//import CarRentalCTA from "pages/CarRentals/sections/CarRentalCTA";

// Routes
import routes from "routes";
import footerRoutes from "footer.routes";

function CarRentals() {
  return (
    <>
      <SEO
        title="Car Rentals & Free Airport Transfers"
        description="Rent vehicles directly with Stalley Beach House: a brand-new 2027 Hyundai Staria van and a 2017 Toyota RAV4 SUV, plus free two-way airport transfers to and from the property in Costa Rica."
        path="/car-rentals"
        imageAlt="Brand-new 2027 Hyundai Staria van available to rent at Stalley Beach House"
        schema={buildBreadcrumbSchema([
          { name: "Home", path: "/" },
          { name: "Car Rentals", path: "/car-rentals" },
        ])}
      />
      <DefaultNavbar routes={routes} sticky />
      <MKBox pt={12}>
        <Card
          sx={{
            p: 2,
            mx: { xs: 2, lg: 3 },
            mb: 4,
            boxShadow: ({ boxShadows: { xxl } }) => xxl,
          }}
        >
          <HowItWorks />
          <Fleet />
          <LargerGroupNote />
          <Terms />
          <VanGallery />
        </Card>
      </MKBox>
      <MKBox pt={6} px={1} mt={6}>
        <DefaultFooter content={footerRoutes} />
      </MKBox>
    </>
  );
}

export default CarRentals;
